import React, { useState } from 'react';
import { Button } from '@asigna/kit';
import cx from 'classnames';
import DeleteIcon from 'images/delete_icon.svg';
import { Owner } from 'types/createSafeTypes';
import { shortenAddress } from 'utils/helper';

interface OwnerItemProps {
  owner: Owner;
  index: number;
  walletAccount: string;
  removeOwner: (ownerToRemove: Owner) => void;
  onEditOwnerName: (owner: Owner) => void;
}

export const OwnerItem: React.FC<OwnerItemProps> = ({
  owner,
  index,
  walletAccount,
  removeOwner,
  onEditOwnerName,
}) => {
  const [name, setName] = useState(owner.name);
  const [isEdited, setEdited] = useState(false);

  return (
    <>
      {isEdited && (
        <div
          className="fixed inset-0 z-10"
          onClick={() => {
            setEdited(false);
            setName(owner.name);
          }}
        />
      )}
      <div
        className={cx(
          'flex items-center justify-between rounded-[6px] px-16 py-4 bg-white-3 h-36 border border-[.5px]',
          isEdited ? 'border-primary' : 'border-black-2',
          walletAccount !== owner.address && 'hover:cursor-text'
        )}
        onClick={() => {
          walletAccount !== owner.address && setEdited(true);
        }}
      >
        <div
          className={cx(
            'grid grid-cols-2 justify-between gap-4 flex-1 items-center',
            isEdited && 'z-20'
          )}
        >
          <p className="text-r12 text-white">{shortenAddress(owner.address)}</p>
          {isEdited ? (
            <input
              type="text"
              autoFocus
              value={name}
              className="border-0 h-32 bg-[transparent] text-r13 active:border-0 focus:outline-none focus-visible:border-0"
              onChange={(e) => setName((e.target as HTMLInputElement).value)}
            />
          ) : (
            <p className={cx('text-r13', owner.name === '' ? 'text-primary' : 'text-regular')}>
              {owner.name === '' ? '+ Add name' : owner.name}
            </p>
          )}
        </div>
        {isEdited ? (
          <Button
            size="sm"
            colorType="inherit"
            onClick={() => {
              setEdited(false);
              onEditOwnerName({ name: name, address: owner.address });
            }}
            disabled={!Boolean(name)}
            message="Save"
            fontColor="primary"
            className="!px-0 active:outline-none focus-visible:outline-none z-20 w-[30rem]"
            fontSize="r13"
          />
        ) : !(index === 0 && owner.name === 'Me' && owner.address === walletAccount) ? (
          <button
            onClick={() => {
              removeOwner(owner);
            }}
            className="flex w-[30rem] justify-end"
          >
            <img src={DeleteIcon} width={16} height={16} alt="delete" />
          </button>
        ) : (
          <div className="w-[30rem]" />
        )}
      </div>
    </>
  );
};
